/**
 * @type {string} エンドポイント定義です。
 */
const PORTAL_ENDPOINT = 'PortalAPI';
const BASE_ENDPOINT = 'BaseAPI';

export { PORTAL_ENDPOINT, BASE_ENDPOINT };

/**
 * API情報のクラスです。
 * @constructor
 * @param {string} path
 * @param {string} endpointType デフォルトはBaseAPIとなる。ポータルを参照する場合はPORTAL_ENDPOINTを指定する。
 */

export class ApiInfo {
  constructor(public path: string, public endpointType = BASE_ENDPOINT) {}
}

export default Object.freeze({
  auth: {
    login: new ApiInfo('/login'),
    ipLogin: new ApiInfo('/ip-login'),
    isAllowIp: new ApiInfo('/is-allow-ip'),
    logout: new ApiInfo('/logout'),
    MicrosoftSsoLogin: new ApiInfo('/microsoft-sso-login'),
    GoogleSsoLogin: new ApiInfo('/google-sso-login'),
  },
  user: {
    getUser: new ApiInfo('/get-user'),
    updateUser: new ApiInfo('/update-user'),
    updatePassword: new ApiInfo('/update-password'),
  },
  ops: {
    getNotification: new ApiInfo('/get-notification'),
  },
  master: {
    getSchoolList: new ApiInfo('/get-school-list'),
    getSetNameList: new ApiInfo('/get-set-name-list'),
    getPeriodControl: new ApiInfo('/get-period-control'),
    getWhitelist: new ApiInfo('/get-whitelist'),
  },
  clientRegistration: {
    clientRegistration: new ApiInfo('/client-registration'),
    sharedidClientRegistration: new ApiInfo('/sharedid-client-registration'),
    fixedipClientRegistration: new ApiInfo('/fixedip-client-registration'),
    validateSchoolContractSelection: new ApiInfo('/validate-school-selection'),
    nextgigaClientRegistration: new ApiInfo('/nextgiga-client-registration'),
  },
  news: {
    getAsagakuList: new ApiInfo('/get-asagaku-list'),
  },
  maintenance: {
    getServiceStatus: new ApiInfo('/get-service-status'),
  },
  event: {
    operationEvent: new ApiInfo('/operation-event'),
  },
});
